import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  BadgeContainer,
  LabelBadge,
  BadgeLabel,
  GradeBadge,
  NoiseBadge,
  NoiseValue,
  NoiseDb,
  NoiseWaves,
  Wave,
} from './EULabelBadge.style';

const getLabelColor = (grade) => {
  const colors = {
    A: '#00a651',
    B: '#4fb84f',
    C: '#ffd500',
    D: '#ff8c00',
    E: '#e53935',
  };
  return colors[grade?.toUpperCase()] || '#999';
};

const EULabelBadge = ({ rollingResistance, wetPerformance, noiseLevel, noiseType }) => {
  const { t } = useTranslation();

  const getNoiseWaveCount = (type) => {
    const typeMap = { A: 1, B: 2, C: 3 };
    return typeMap[type?.toUpperCase()] || 2;
  };

  const activeWaves = getNoiseWaveCount(noiseType);

  return (
    <BadgeContainer>
      {rollingResistance && (
        <LabelBadge>
          <BadgeLabel>{t('fuel')}</BadgeLabel>
          <GradeBadge color={getLabelColor(rollingResistance)}>
            {rollingResistance.toUpperCase()}
          </GradeBadge>
        </LabelBadge>
      )}

      {wetPerformance && (
        <LabelBadge>
          <BadgeLabel>{t('grip')}</BadgeLabel>
          <GradeBadge color={getLabelColor(wetPerformance)}>
            {wetPerformance.toUpperCase()}
          </GradeBadge>
        </LabelBadge>
      )}

      {noiseLevel != null && noiseLevel > 0 && (
        <NoiseBadge>
          <BadgeLabel>{t('noise')}</BadgeLabel>
          <NoiseValue>
            {noiseLevel}
            <NoiseDb>dB</NoiseDb>
          </NoiseValue>
          <NoiseWaves>
            <Wave active={activeWaves >= 1} />
            <Wave active={activeWaves >= 2} />
            <Wave active={activeWaves >= 3} />
          </NoiseWaves>
        </NoiseBadge>
      )}
    </BadgeContainer>
  );
};

EULabelBadge.propTypes = {
  rollingResistance: PropTypes.string,
  wetPerformance: PropTypes.string,
  noiseLevel: PropTypes.number,
  noiseType: PropTypes.string,
};

export default EULabelBadge;
